module.exports = __webpack_public_path__ + "media/theme/icon__payment__master-072db1d5.svg";